const mobileUserAgentRegExp = /Android|iPhone|iPad|Windows Phone/i;

export default function isMobile() {
  const userAgent = typeof navigator !== 'undefined' && navigator.userAgent;

  return userAgent && userAgent.match(mobileUserAgentRegExp);
}
